<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2 class="page__title">Добавить тариф</h2>
        <el-tabs>
          <el-tab-pane label="Настройка">
            <el-form
              class="page__form"
              id="formCreateTariff"
              :model="tariff"
              ref="form"
              :rules="rules"
              label-position="right"
              label-width="180px"
            >
              <el-form-item label="Название" prop="name">
                <el-input id="name" size="small" v-model="tariff.name" />
              </el-form-item>
              <el-form-item label="Срок хранения архива" prop="archive_depth">
                <el-input id="archive_depth" v-model="tariff.archive_depth" size="small"/>
              </el-form-item>
              <el-form-item label="Стоимость в сутки" prop="price_per_day">
                <el-input id="price_per_day" v-model="tariff.price_per_day" size="small"/>
              </el-form-item>
              <el-form-item label="Урезанный битрейт" prop="is_default">
                <el-switch
                  id="is_default"
                  size="small"
                  :active-value="0"
                  :inactive-value="1"
                  v-model="tariff.is_default"
                  @change="resetBitrate"                  
                />
              </el-form-item>
              <el-form-item label="Битрейт" prop="bitrate" v-if="!tariff.is_default">
                <el-input id="bitrate" size="small" v-model="tariff.bitrate" />
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button class="page__active_button" id="submit" icon="el-icon-check" type="primary" @click="submit">
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapActions } from "vuex";
import { required, validatorNumber } from "@/core/helpers/validators";
import { ApiService } from "@/api";

export default {
  name: "TariffCreate",
  data() {
    return {
      tariff: {
        name: "",
        archive_depth: null,
        bitrate: null,
        price_per_day: null,
        is_default: 1,
      },
      rules: {
        name: [required()],
        archive_depth: [required(), validatorNumber],
        price_per_day: [required(), validatorNumber],
        bitrate: [required(), validatorNumber],
      },
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.createTariff()
        }
        return valid;
      });
    },
    resetBitrate() {
      if (this.tariff.is_default == 1) {
        this.tariff.bitrate = null
      }
    },
    createTariff() {
      ApiService.tariffs
        .create(this.tariff)
        .then(() => {
          this.$message({
            message: `Тариф "${this.tariff.name}" успешно создан`,
            type: "success",
          });
        })
        .catch((e) => {
          this.$message({
            message: e.response.data.error,
            type: "error",
          });
        });
    },
  },
};
</script>
